export const localValidate = (formState) => {
  let hasRequiredField = false;
  let errors = {};

  if (formState.eventId > 0) {
    hasRequiredField = true;
  }

  return errors;
};

const RecordsAdminEventsValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default RecordsAdminEventsValidation;